import {
  UPDATE_JOURNAL_ZONES_LIST,
  TOGGLE_JOURNAL_ZONES_LOADING,
  JOURNAL_ZONES_ERROR,
  JOURNAL_ZONES_UPDATE_TOTAL
} from '../actions/journalZonesActions'

const initState = {
  name: 'Journal Zones',
  zones: {
    loading: true,
    list: [],
    error: null,
    totalRecords: 0
  }
}

const journalZonesReducer = (state = initState, action) => {
  switch (action.type) {
    case UPDATE_JOURNAL_ZONES_LIST:
      return { ...state, zones: { ...state.zones, list: action.payload.value } }
    case JOURNAL_ZONES_UPDATE_TOTAL:
      return { ...state, zones: { ...state.zones, totalRecords: action.payload.value } }
    case TOGGLE_JOURNAL_ZONES_LOADING:
      return { ...state, zones: { ...state.zones, loading: action.payload.value } }
    case JOURNAL_ZONES_ERROR:
      return { ...state, zones: { ...state.zones, error: action.payload.value } }
    default:
      return state
  }
}

export default journalZonesReducer
